/**
 * Returns whether any prices are part of an item test
 */
export var isInItemTest = function isInItemTest(_ref) {
  var _prices$some;
  var prices = _ref.prices;
  return (_prices$some = prices === null || prices === void 0 ? void 0 : prices.some(function (_ref2) {
    var pricePlans = _ref2.eligibility.pricePlans;
    return pricePlans === null || pricePlans === void 0 ? void 0 : pricePlans.itemTestVariation;
  })) !== null && _prices$some !== void 0 ? _prices$some : false;
};

/**
 * Returns whether a vpn is detected
 */
export var isVpnDetected = function isVpnDetected(_ref3) {
  var isVpn = _ref3.isVpn;
  return isVpn !== null && isVpn !== void 0 ? isVpn : false;
};

/**
 * Returns whether the user is allocated into any excluded Optimizely Full Stack experiments
 */
export var isAllocatedToExcludedExperiment = function isAllocatedToExcludedExperiment(_ref4) {
  var _ref5;
  var experimentsToExclude = _ref4.experimentsToExclude,
    optimizelyClient = _ref4.optimizelyClient;
  return (_ref5 = optimizelyClient && (experimentsToExclude === null || experimentsToExclude === void 0 ? void 0 : experimentsToExclude.some(function (_ref6) {
    var id = _ref6.id,
      userId = _ref6.userId,
      attributes = _ref6.attributes;
    return typeof optimizelyClient.getVariation(id, userId, attributes) === 'string';
  }))) !== null && _ref5 !== void 0 ? _ref5 : false;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/conditions.js
// module id = 1360
// module chunks = 11